// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
These variables will be updated within the CybersourceForm component to conform with
the current theme being used on the Kanopi platform.
*/
:root {
  --cybersource-inactive-border: #eeeeee;
  --cybersource-focused-border: black;
}

.flex-microform {
  border-bottom: 1px solid var(--cybersource-inactive-border);
}

.flex-microform-focused {
  border-bottom: 1px solid var(--cybersource-focused-border);
}
`, "",{"version":3,"sources":["webpack://./src/quoting/components/PaymentForm/cybersourceStyles.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,0DAA0D;AAC5D","sourcesContent":["/*\nThese variables will be updated within the CybersourceForm component to conform with\nthe current theme being used on the Kanopi platform.\n*/\n:root {\n  --cybersource-inactive-border: #eeeeee;\n  --cybersource-focused-border: black;\n}\n\n.flex-microform {\n  border-bottom: 1px solid var(--cybersource-inactive-border);\n}\n\n.flex-microform-focused {\n  border-bottom: 1px solid var(--cybersource-focused-border);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
